export default __webpack_public_path__ + "img/8d581a4c3c6f4a6bad229781093dde2e.svg";